/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlZeroDayAlertClientNotificationEvent
 */
export interface ControlZeroDayAlertClientNotificationEvent {
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientNotificationEvent
     */
    zero_day_alert_id: string;
    /**
     * 
     * @type {number}
     * @memberof ControlZeroDayAlertClientNotificationEvent
     */
    alert_version: number;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientNotificationEvent
     */
    event_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientNotificationEvent
     */
    sent: string;
}

/**
 * Check if a given object implements the ControlZeroDayAlertClientNotificationEvent interface.
 */
export function instanceOfControlZeroDayAlertClientNotificationEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zero_day_alert_id" in value;
    isInstance = isInstance && "alert_version" in value;
    isInstance = isInstance && "event_id" in value;
    isInstance = isInstance && "sent" in value;

    return isInstance;
}

export function ControlZeroDayAlertClientNotificationEventFromJSON(json: any): ControlZeroDayAlertClientNotificationEvent {
    return ControlZeroDayAlertClientNotificationEventFromJSONTyped(json, false);
}

export function ControlZeroDayAlertClientNotificationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertClientNotificationEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zero_day_alert_id': json['zero_day_alert_id'],
        'alert_version': json['alert_version'],
        'event_id': json['event_id'],
        'sent': json['sent'],
    };
}

export function ControlZeroDayAlertClientNotificationEventToJSON(value?: ControlZeroDayAlertClientNotificationEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zero_day_alert_id': value.zero_day_alert_id,
        'alert_version': value.alert_version,
        'event_id': value.event_id,
        'sent': value.sent,
    };
}

